<template>

    <div>
        <el-form :inline="true" :model="query" class="query-form">
            <!-- <el-form-item>
                <el-button type="primary" icon="el-icon-edit" @click.native="handleForm(null,null)">添加</el-button>
            </el-form-item> -->
            <el-form-item class="query-form-item"  size="mini" >
                <el-input v-model="query.keyword" placeholder="请输入用户名"></el-input>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item"  size="mini" >
                <el-select v-model="query.is_rule" placeholder="角色">
                    <el-option label="全部" value=''></el-option>
                    <el-option label="普通" value="1"></el-option>
                    <el-option label="认证" value="2"></el-option>
                    <el-option label="Pro" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item"  size="mini" >
                <el-select v-model="query.type" placeholder="分类">
                    <el-option label="全部" value=''></el-option>
                    <el-option label="有写操作用户" value="2"></el-option>
                    <el-option label="仅读操作用户" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item"  size="mini" >
                <el-select v-model="query.is_examine" placeholder="状态">
                    <el-option label="全部" value=''></el-option>
                    <el-option label="未审核" value="1"></el-option>
                    <el-option label="审核通过" value="2"></el-option>
                    <el-option label="审核未通过" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item"  size="mini" >
                <el-select v-model="query.order" placeholder="时间">
                    <el-option label="倒序" value="desc"></el-option>
                    <el-option label="正序" value="asc"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item class="query-form-item">
                <el-input v-model="query.id" placeholder="用户ID"></el-input>
            </el-form-item>  -->
<!--            <el-form-item class="query-form-item">-->
<!--                <el-select v-model="query.province_id" placeholder="省">-->
<!--                    <el-option-->
<!--                        v-for="item in provincesData"-->
<!--                        :key="item.value"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="query-form-item">-->
<!--                <el-select v-model="query.city_id" placeholder="市"> <el-option v-for="item in citysData" :key="item.value" :label="item.label" :value="item.value"> </el-option> </el-select>-->
<!--            </el-form-item>-->
            <el-form-item>
                <el-button-group style="vertical-align: top;">
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset" size="mini">重置</el-button>
                    <el-button type="primary" icon="search" @click="onSubmit"  size="mini">查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" style="width: 100%;">
            <el-table-column label="用户头像">
                <template slot-scope="scope">
                    <!-- <img :src="default_user_image_url" v-if="scope.row['ex_image'] == '' " style="width: 40px;height: 40px;"> -->
                    <img :src="scope.row.image"  style="width: 40px;height: 40px;">
                </template>
            </el-table-column>
            <el-table-column label="用户待审核头像">
                <template slot-scope="scope">
                    <img :src="scope.row.ex_image" v-if="scope.row['ex_image'] != null "  style="width: 40px;height: 40px;">
                    <span v-else></span>
                    <!-- <img :src="scope.row.ex_image" v-else  style="width: 40px;height: 40px;"> -->
                </template>
            </el-table-column>
            <el-table-column label="用户 ID" prop="user_id" fixed> </el-table-column>
            <el-table-column label="昵称" prop="ex_nick" fixed> </el-table-column>
            <el-table-column label="简介" prop="ex_autograph" fixed>
            </el-table-column>
            <el-table-column label="审核状态">
                <template slot-scope="scope">
                    <template v-if="scope.row['is_examine'] == 1">待审核</template>
                    <template v-if="scope.row['is_examine'] == 2">通过</template>
                    <template v-if="scope.row['is_examine'] == 3">未通过</template>
                </template>
            </el-table-column>
            <el-table-column label="注册时间" prop="create_time"> </el-table-column>

<!--            <el-table-column label="禁止登录">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-switch-->
<!--                      @change="switchChange(scope.row)"-->
<!--                      v-model="scope.row.status"-->
<!--                      :active-value="1"-->
<!--                      :inactive-value="2"-->
<!--                      active-color="#13ce66"-->
<!--                      inactive-color="#ff4949">-->
<!--                    </el-switch>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                label="操作"
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native="jump(scope.row)">查看
                    </el-button>
<!--                    <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row)">删除-->
<!--                    </el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <!-- <el-pagination :page-size="query.page_size" @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"> </el-pagination> -->
        <el-pagination class="pagination-container"
            style="height:50px;"
            background
            :page-size="page_size"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="total"
            :current-page.sync="query.page">
        </el-pagination>
        <!--表单-->
        <el-dialog
            :title="formMap[formName]"
            :visible.sync="formVisible"
            :before-close="hideForm"
            v-loading="dialogLoading"
            width="20%"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="用户昵称" prop="nick">
                    <el-input v-model="formData.nick" placeholder="请输入用户昵称" clearable ></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="tel">
                    <el-input v-model="formData.tel" placeholder="请输入手机号码" clearable ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pw">
                    <el-input v-model="formData.pw" placeholder="请输入密码" type="password" clearable ></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button v-if="formName === 'view'" disabled type="primary">提交</el-button>
                <el-button v-else type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    changeLoginStatus, usersList, userDel,userSave
} from "../../../api/app-users/user";

const formJson = {
    nick: "",
    tel: "",
    pw: "",
    is_all: true,
    type: 1,
    users: []
};
export default {
    data() {
        return {
            default_user_image_url: "http://images.caifuzhongwen.com/ios1575887112504.jpg",
            provincesData: [],
            citysData: [],
            query: {
                is_examine:"",
                type: "",
                is_rule: "",
                order: "",
                page: 1,
            },
            page_size: 10,
            list: [],
            total: 0,
            loading: true,
            deleteLoading: false,
            dialogLoading: false,
            formMap: {
                add: "新增",
                view: "查看"
            },
            formName : null,
            formVisible: false,
            formData: formJson,
            formRules: {},
            formLoading: false,
        };
    },
    watch: {
        'query.province_id': function (v) {
            this.query.city_id = "";
            if (v > 0)
            {
                citys({provinces_id: v}).then(response => {
                    this.citysData = response.data.map(function (v) {
                        return { label: v.name, value: v.id };
                    });
                })
            }
        }
    },
    methods: {
        // 显示表单
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.dialogLoading = true;
                message({id: row.id}).then(response => {
                    this.formData = {
                        title: response.data.title,
                        content: response.data.text,
                        is_all: !(response.data.users.length > 0),
                        type: response.data.jump_id,
                        users: []
                    };
                    if (response.data.users.length > 0) {
                        this.formData.users = response.data.users.map(v => v.id);
                        this.checkedUsersData = response.data.users;
                    }
                    this.dialogLoading = false;
                })
            }
            this.formName = "add";
            this.formRules = this.addRules;
            if (index !== null) {
                this.index = index;
                this.formName = "view";
                this.formRules = this.editRules;
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    userSave(data).then(response => {
                        this.formLoading = false;
                        if (response.code)
                        {
                            this.$message({ message: response.message, type: "error" });
                        }
                        else
                        {
                            this.initUsers();
                            this.$message({ message: "操作成功", type: "success" });
                            this.$refs["dataForm"].resetFields();
                            this.formVisible = false;
                            this.getList();
                        }
                    });
                }
            });
        },
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            return true;
        },
        switchChange(row) {
            changeLoginStatus({ id: row.id }).then(response => {
                if (response.code) {
                    this.$message.error(response.message);
                } else {
                    this.hideForm();
                    this.getList();
                }
            });
        },
        getProvinces() {
            provinces({}).then(response => {
                this.provincesData = response.data.map(function (v) {
                    return { label: v.name, value: v.id };
                });
            });
        },
        onReset() {
            sessionStorage.setItem( "currentPage_normalUsersAdmin", 1);

            this.$router.push({
                path: ""
            });
            this.query = {
                is_examine:"",
                type: "",
                is_rule: "",
                order: "",
                page: 1,
                page_size: 10,
            };
            this.getList();
        },
        onSubmit() {
            this.query.page = 1;

            console.log(this.query,'this.query');
            // this.$router.push({
            //     path: "",
            //     query: this.query
            // });
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            sessionStorage.setItem( "currentPage_normalUsersAdmin", val);
            this.getList();
        },
        getList() {
            this.loading = true;
            usersList(this.query)
                .then(response => {
                    this.loading = false;
                    this.list = response.data.data || [];
                    this.total = response.data.total || 0;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                    this.roles = [];
                });
        },
        // 显示表单
        jump(row) {
            this.$router.push({ path: `/userManage/customerManage/normalUsers/${row.user_id}` });
        },
        // 删除
        handleDel(index, row) {
            if (row.user_id) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        userDel({ user_id: row.user_id }).then(response => {
                            this.getList();
                        })
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
            }
        }
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success",
                2: "danger"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "禁用",
                1: "正常",
                2: "未验证"
            };
            return statusMap[status];
        }
    },
    created() {
        this.query.page = Number(sessionStorage.getItem("currentPage_normalUsersAdmin")) || 1;

        sessionStorage.setItem( "currentPage_advertList", 1);
        sessionStorage.setItem( "currentPage_findList", 1);
        sessionStorage.setItem( "currentPage_findVideoList", 1);
        sessionStorage.setItem( "currentPage_messageList", 1);
        sessionStorage.setItem( "currentPage_editorList", 1);
        sessionStorage.setItem( "currentPage_userList", 1);


        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit) ? parseInt(this.query.limit) : 10;
        // this.query.page = 1;
        // 加载表格数据
        this.getList();

        var that = this;
        document.onkeydown = function(e) {
            var key = window.event.keyCode;
            if (key == 13) {
                that.getList();

            }
        }
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
